<template>
    <section class="p-[16px]">
        <div class="mb-[16px] flex items-center justify-between">
            <h2 class="text-[18px] text-[#2b2b2b] font-light">Liste des Employés</h2>
            <button @click="pushOnCreate" className="flex font-light items-center h-[36px] px-8 rounded-md text-white bg-[#3c41e9]">
                <UserPlus :size="16" strokeWidth="1.3"/>
                <span class="ml-[6px]">Ajouter un employé</span>
            </button>
        </div>
        <div class="">
            <EmployeeTableComponent />
        </div>

    </section>
</template>

<script>
import EmployeeTableComponent from '@/components/tables/EmployeeTable'
// import AddUser from '@/components/create/add-user.vue'
import {UserPlus} from "lucide-vue-next";
export default {
    name: 'EmployeeView',
    components: {
        EmployeeTableComponent,
        UserPlus
        // AddUser
    },
    data() {
        return {
            loader: false,
        }
    },
    computed: {
        comp1() {
            return ""
        }
    },
    mounted() {
        this.loadpage()
    },
    created() {

    },
    methods: {
        loadpage() {
            this.loader = true
            var data = this
            setTimeout(() => {
                data.loader = false
            }, 500);
        },
        pushOnCreate(){
            this.$router.push("/new-user");
        }
    }
}

</script>